import styled from '@emotion/styled'
import { useTranslation } from 'react-i18next'

import type { Spacing } from '@cash-design-system/react'
import { Header, spacing } from '@cash-design-system/react'

type FontWeight = 500 | 600
type MarginBottom = Spacing | '0'
interface SupportSuperDuperMainTitleProps {
  fontWeight?: FontWeight
  marginBottom?: MarginBottom
}

const SupportSuperDuperMainTitle = ({ fontWeight = 600, marginBottom = 'xl' }: SupportSuperDuperMainTitleProps) => {
  const { t } = useTranslation()

  const MainHeader = styled(Header)`
    font-weight: ${fontWeight};
    margin-bottom: ${marginBottom === '0' ? '0' : spacing[marginBottom]};
  `
  return (
    <MainHeader variant="largeLabel" as="h1">
      {t('Support', { context: 'Support Home title' })}
    </MainHeader>
  )
}

export default SupportSuperDuperMainTitle
